module.exports = __webpack_public_path__ + "static/media/right_illustration.2b0dc439.png";